module.exports = __webpack_public_path__ + "img/icon-kiosk-01.svg";